var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2A2441"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.16351402,0 0,7.16339796 0,16.0000748 C0,24.836602 7.16351402,32 16,32 C24.8366355,32 32,24.836602 32,16.0000748 C32,7.16339796 24.8366355,0 16,0 M17.3641869,24.8866957 L17.3641869,27.2108935 L15.0917383,27.2108935 L15.0917383,24.8866957 C12.164486,24.6804892 9.9753271,23.6204468 8.46893458,22.2007766 L10.3455701,19.8492142 C11.3961869,20.9092566 13.0437383,21.8894481 15.0917383,22.1755055 L15.0917383,17.1610522 C12.164486,16.4921892 9.09368224,15.5351754 9.09368224,12.1762064 C9.09368224,9.54277356 11.424,7.44990397 15.0917383,7.16594003 L15.0917383,4.78925602 L17.3641869,4.78925602 L17.3641869,7.19121117 C19.6665421,7.42253936 21.5988037,8.25125351 23.0775327,9.54277356 L21.2008972,11.789214 C20.1202243,10.8088729 18.7572336,10.21373 17.3641869,9.95503717 L17.3641869,14.4245908 C20.3192523,15.1208183 23.5310654,16.1304679 23.5310654,19.5905215 C23.5310654,22.2258983 21.6267664,24.550096 17.3641869,24.8866957",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.42,17.6 L17.42,22.250519 C19.405133,21.9829901 20.208081,20.8865853 20.208081,19.8447689 C20.208081,18.6439814 19.0024489,18.0568095 17.42,17.6",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.28,11.9932036 C12.28,12.9175457 13.4446414,13.3902799 15.068081,13.7704152 L15.068081,10.05 C13.3523016,10.215992 12.28,10.9511581 12.28,11.9932036",
    id: "Fill-6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.8d2ced29e795163eaf151966fdb1da9d.svg";
export { ForwardRef as ReactComponent };